import { Copy, BadgeCheck } from 'lucide-react';
import { Button } from '../../ui/button.tsx';
import { toast } from 'sonner';

interface AccountCreatedSuccessProps {
  email: string;
  password: string;
  name: string;
  onClose: () => void;
}

export const Success = ({ 
  email, 
  password, 
  name, 
}: AccountCreatedSuccessProps) => {

  const copyToClipboard = (text: string, field: string) => {
      navigator.clipboard.writeText(text);
      toast.success(`${field} copied to clipboard`);

  };

  const fullCredentials = `Login: ${email}\nPassword: ${password}`;

  return (
    <div className="flex flex-col items-center justify-center py-10">
      <BadgeCheck className="size-12 text-green-400" />
      <h3 className="text-lg font-semibold text-green-500 mb-2">Account Successfully Created !</h3>
      <p className="text-sm text-muted-foreground mb-4">Email with credentials sent to {email}.
        <br />Share credentials with {name}.</p>
      <div className="flex items-start p-3 bg-gray-50 rounded-lg border w-full font-mono mb-10">
        <div className="flex-1">
          <pre className="text-sm font-mono whitespace-pre-wrap">{fullCredentials}</pre>
        </div>
        <Button
          size="sm"
          variant="outline"
          onClick={() => copyToClipboard(fullCredentials, 'All Credentials')}
          className="size-8 p-0 flex-shrink-0"
        >
          <Copy className="size-3" />
        </Button>
      </div>
    </div>
  );
};
